/**
 * クリップボードコピー + 2秒フィードバックのカスタムhook
 */
import { useCallback, useState } from 'react';
export function useCopyToClipboard(options) {
    const [copied, setCopied] = useState(false);
    const onError = options?.onError;
    const copy = useCallback(async (text) => {
        try {
            await navigator.clipboard.writeText(text);
            setCopied(true);
            setTimeout(() => {
                setCopied(false);
            }, 2000);
            return true;
        }
        catch (error) {
            console.error('Failed to copy to clipboard:', error);
            onError?.(error);
            return false;
        }
    }, [onError]);
    return { copied, copy };
}
//# sourceMappingURL=use-copy-to-clipboard.js.map